import { useMemo } from "react";
import PropTypes from "prop-types";

import { alignItems, colors, strCode } from "../../../../../consts";
import { t } from "../../../../../services";
import { useMarketLocalizations } from "../../hooks/useMarketLocalizations";

import {
  FlexContainers,
  IconButton,
  Paragraph2,
  SmallButton,
  SVG,
  WrapperContainer
} from "../../../../../components";
import { MarketItemStyled, ButtonsWrapper } from "./styled";

export const MarketItem = ({
  market,
  name,
  marketsWithoutConsents,
  isReadOnlyAccess,
  onConsentsOpen,
  onSettingsOpen,
  onLocationsOpen,
  onLocalizationsOpen,
  onRemove
}) => {
  const marketLocalizations = useMarketLocalizations(market);

  const isConsentsMissing = useMemo(() => {
    return marketsWithoutConsents.includes(market);
  }, [market, marketsWithoutConsents]);

  return (
    <MarketItemStyled Container={FlexContainers.FlexColumnBetween} alignItems={alignItems.start}>
      <Paragraph2>{name ?? market}</Paragraph2>

      <ButtonsWrapper Container={FlexContainers.FlexRowBetween} gap={16} width={"100%"}>
        <WrapperContainer Container={FlexContainers.FlexRowStart} gap={16}>
          <IconButton onClick={() => onLocalizationsOpen(market)}>
            <SVG.LanguageIcon />
            <Paragraph2>{marketLocalizations?.length ?? 0}</Paragraph2>
          </IconButton>
          <IconButton onClick={() => onLocationsOpen(market)}>
            <SVG.LocationIcon />
          </IconButton>
          <IconButton onClick={() => onSettingsOpen(market)}>
            <SVG.SettingsIcon />
          </IconButton>
          <IconButton disabled={isReadOnlyAccess} onClick={() => onRemove(market)}>
            <SVG.DeleteIcon color={colors.ERROR} />
          </IconButton>
        </WrapperContainer>

        <SmallButton secondary onClick={() => onConsentsOpen(market)}>
          {isConsentsMissing ? <SVG.CrossMark /> : <SVG.CheckMark />}
          {t(strCode.CONSENTS_NAV_BTN)}
        </SmallButton>
      </ButtonsWrapper>
    </MarketItemStyled>
  );
};

MarketItem.propTypes = {
  market: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  marketsWithoutConsents: PropTypes.arrayOf(PropTypes.string).isRequired,
  isReadOnlyAccess: PropTypes.bool.isRequired,
  onConsentsOpen: PropTypes.func.isRequired,
  onSettingsOpen: PropTypes.func.isRequired,
  onLocationsOpen: PropTypes.func.isRequired,
  onLocalizationsOpen: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};
